// extracted by mini-css-extract-plugin
export default {"bar":"InTaxHeaderBar_bar__X+dk8"};